import { render, staticRenderFns } from "./OtpInputItem.vue?vue&type=template&id=fa34ab98&"
import script from "./OtpInputItem.vue?vue&type=script&lang=js&"
export * from "./OtpInputItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports